import type { ReactNode } from 'react';
import { Toggle } from '@/components/ui/Toggle';

interface ToggleRowProps {
  title: ReactNode;
  description?: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  disabledReason?: string;
}

/**
 * docs/DESIGN_SYSTEM.md §4.4 — "[label] [description] [toggle]", never a
 * bare grid of switches. The row-level pattern every settings grid in the
 * dashboard (AutoMod's 12 protections, Security AI's 4 toggles, Logging's
 * 12 event types) is built from.
 */
export function ToggleRow({
  title,
  description,
  checked,
  onChange,
  disabled,
  disabledReason,
}: ToggleRowProps) {
  return (
    <div className="flex items-start justify-between gap-4 py-3 first:pt-0 last:pb-0">
      <div className="min-w-0">
        <p className="text-body-medium text-text-primary">{title}</p>
        {description ? <p className="text-small text-text-secondary mt-0.5">{description}</p> : null}
        {disabled && disabledReason ? (
          <p className="text-small text-text-tertiary mt-1">{disabledReason}</p>
        ) : null}
      </div>
      <Toggle
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        label={typeof title === 'string' ? title : 'toggle'}
      />
    </div>
  );
}
